import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LoansPlan from './LoansPlan';
import MobilPlan from './MobilPlan';
import { Link, navigate } from '@reach/router';
import handShake from '../../icons/handShake.png';
import blur from '../../icons/blur.jpg';

const propTypes = {
  getLoans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default function Loans(props) {
  const { getLoans } = props;

  return (
    <PageWrapper>
      <h1>Úvěry</h1>
      <LoansPlan />
      <MobilPlan />
      <LoansContainer>
        <Box onClick={() => navigate('/objednatkuveru')}>
          <h3>Domluvit schůzku</h3>
          <Link to='/objednatkuveru'>
            <Text>
              <p>Objednejte se</p>
            </Text>
          </Link>
          <MoneyPic src={handShake} />
        </Box>
        <TextContainer>
          <h2>Obvyklý účel úvěru:</h2>
          <ul>
            {getLoans.map((i) => (
              <li key={i.id}>{i.text}</li>
            ))}
          </ul>
          <h3>A další možnosti dle konzultace...</h3>
        </TextContainer>
      </LoansContainer>
    </PageWrapper>
  );
}

Loans.propTypes = propTypes;

const MoneyPic = styled.img`
  width: 100%;
  border-radius: 0 0 15px 15px;
  margin-bottom: -6px;
  background: url(${blur});
  background-repeat: no-repeat;
  background-size: cover;
`;
const Text = styled.div`
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translate(-50%,0);
  background: rgba(255,0,0, .6);
  padding: 0 12px;

  p {
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.common.black};
    font-weight: 600;
  }
`;
const Box = styled.div`
  width: 100%;
  max-width: 320px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  margin: 0 36px;
  position: relative;
  transition: all .6s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    @media(max-width: 650px) {
      transform: scale(1);
    }
  }
  @media(max-width: 450px) {
    margin: 24px 0;
  }

`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  ul {
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
    @media(max-width: 650px) {
      columns: 1;
      -webkit-columns: 1;
      -moz-columns: 1;
    }
  }
  li {margin: 0 12px; padding-right: 48px;}
  h3 {text-align: left !important;}

`;
const LoansContainer = styled.div`
  display: flex;
  justify-content:center;
  align-items: center;
  @media(max-width: 1200px) {
    flex-direction: column-reverse;
    align-items: center;
    h3 {text-align: center !important;}
  }
`;

const PageWrapper = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;

  h2 {margin-top: 24px;}
  h3 {text-align: center;}
`;
